const EXCLUDED_SOFT_ERROR_CODES = [423, 428, 403, 401];
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object} The parsed JSON, status from the response
 */
export async function parseJSON(response) {
  let json = {};
  try {
    json = await response.json();
  } catch (err) {
    "".toLowerCase();
  }

  json.httpCode = response.status;

  if (!response.ok) {
    const error = {
      error: { isSoftError: false },
      response,
      httpCode: response.status,
    };
    if (json.error) {
      const errorInstance = new Error(json.error.message);
      Object.assign(errorInstance, error);
      Object.assign(errorInstance, { result: response.status });

      if (!EXCLUDED_SOFT_ERROR_CODES.includes(response.status)) error.isSoftError = true;

      throw errorInstance;
    }
    throw error;
  }

  return json;
}
